import React from "react";

export function Table({ children, className = "", ...props }) {
  return (
    <div className={`overflow-x-auto rounded-lg shadow ${className}`} {...props}>
      <table className="min-w-full border-collapse text-sm">{children}</table>
    </div>
  );
}

export function TableHead({ children }) {
  return <thead className="bg-gray-200 dark:bg-gray-700">{children}</thead>;
}

export function TableBody({ children }) {
  return <tbody>{children}</tbody>;
}

export function TableRow({ children }) {
  return <tr className="hover:bg-gray-100 dark:hover:bg-gray-800">{children}</tr>;
}

export function TableCell({ children, className = "" }) {
  return <td className={`p-2 border-b ${className}`}>{children}</td>;
}

